import {Observable} from 'rxjs';
import {educatAPI} from './provider/educatAPI';

export function getMediaObjectsAPI(authToken: string | null, params: any): Observable<any> {
    let headers = undefined;
    if (authToken) {
        headers = {
            Authorization: `Bearer ${authToken}`,
        };
    }

    return educatAPI.get(
        `media_objects`,
        params,
        headers
    );
}